import { StylesProvider } from '@material-ui/core/styles';
import { Amplify } from 'aws-amplify';
import { BrowserRouter, Switch } from 'react-router-dom';
import AWSConfig from './aws-exports';
import { Notifications } from './components/Notifications';
import { Routes } from './components/Routes';

Amplify.configure(AWSConfig);

export const App = () => (
    <StylesProvider injectFirst>
        <BrowserRouter>
            <Switch >
                <Routes />
            </Switch>
        </BrowserRouter>
        <Notifications />
    </StylesProvider>
);
